import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import MaterialAccordion from "@mui/material/Accordion";
var Accordion = function(param) {
    var title = param.title, children = param.children, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, expanded = param.expanded, handleExpanded = param.handleExpanded;
    return /*#__PURE__*/ _jsxs(MaterialAccordion, {
        expanded: expanded,
        onChange: handleExpanded,
        disabled: disabled,
        children: [
            /*#__PURE__*/ _jsx(AccordionSummary, {
                expandIcon: /*#__PURE__*/ _jsx(ExpandMoreIcon, {}),
                children: /*#__PURE__*/ _jsx(Typography, {
                    children: title
                })
            }),
            /*#__PURE__*/ _jsx(AccordionDetails, {
                children: children
            })
        ]
    });
};
export default Accordion;
